<div class="login-outer">
  <app-card>
    <div class="login-inner">
      <div>Login</div>
      <div><button class="des-button" (click)="login()">Anmelden mit Unternehmenskonto</button></div>
    </div>
  </app-card>
</div>
